export const ALL_TYPES = "all";

export const REDMINE_PROJECT_TYPES = [
  "Backend",
  "BI",
  "Desenvolvimento",
  "Designer",
  "Frontend",
  "Gerenciamento",
  "Infraestrutura",
  "Interno",
  "Manutenção",
  "Mobile",
  "Suporte",
  "Versionamento",
];

const FILTERABLE_TYPES = ["Desenvolvimento", "Manutenção"];

export const PROJECT_TYPE_FILTERS = [
  { value: ALL_TYPES, label: "Todos" },
  ...FILTERABLE_TYPES.map((type) => ({ value: type, label: type })),
];

const TYPE_PILLS = {
  Backend: "type-azure",
  BI: "type-cyan",
  Desenvolvimento: "type-blue",
  Designer: "type-rose",
  Frontend: "type-magenta",
  Gerenciamento: "type-violet",
  Infraestrutura: "type-terra",
  Interno: "type-citron",
  Manutenção: "type-amber",
  Mobile: "type-indigo",
  Suporte: "type-coral",
  Versionamento: "type-orange",
};

export function projectTypeLabel(projectType) {
  return projectType || "Não classificado";
}

export function projectTypePill(projectType) {
  return TYPE_PILLS[projectType] || "none";
}

export function coordinatorName(project) {
  return project?.coordinator || null;
}

// O mesmo sentinela que o backend conhece.
export const UNASSIGNED_COORDINATOR = "__unassigned__";

export function coordinatorLabel(coordinator) {
  return coordinator === UNASSIGNED_COORDINATOR ? "Sem coordenador vinculado" : coordinator;
}

export function coordinatorOptions(payload) {
  const names = payload?.coordinators || [];
  const options = names.map((name) => ({ value: name, label: name }));

  if (!payload?.hasUnassigned) return options;

  return [
    ...options,
    { value: UNASSIGNED_COORDINATOR, label: coordinatorLabel(UNASSIGNED_COORDINATOR) },
  ];
}

// O backend já traduz o inteiro de status do Redmine antes de entregar, então
// aqui chega o nome. Só "active" e "closed" atravessam a API do Redmine — se um
// nome novo aparecer, ele é exibido cru em vez de esvaziar a célula.
const STATUS_LABELS = {
  active: "Ativo",
  closed: "Fechado",
};

const STATUS_PILLS = {
  active: "status-active",
  closed: "status-muted",
};

export const ALL_STATUSES = "all";
export const DEFAULT_STATUS = "active";
const FILTERABLE_STATUSES = ["active", "closed"];

export const PROJECT_STATUS_FILTERS = [
  { value: ALL_STATUSES, label: "Todos" },
  ...FILTERABLE_STATUSES.map((value) => ({ value, label: STATUS_LABELS[value] })),
];

export function projectStatusLabel(projectStatus) {
  if (!projectStatus) return null;
  return STATUS_LABELS[projectStatus] || projectStatus;
}

export function projectStatusPill(projectStatus) {
  return STATUS_PILLS[projectStatus] || "status-muted";
}

const SITUATION_PILLS = {
  Andamento: "success",
  Suspenso: "attention",
  Modelo: "none",
  Teste: "none",
};

export const UNSET_SITUATION = "__unset__";

const FILTERABLE_SITUATIONS = ["Andamento", "Suspenso", "Modelo", "Teste"];

export function situationLabel(situation) {
  return situation === UNSET_SITUATION ? "Sem situação" : situation;
}

export const PROJECT_SITUATION_FILTERS = [
  ...FILTERABLE_SITUATIONS.map((value) => ({ value, label: value })),
  { value: UNSET_SITUATION, label: situationLabel(UNSET_SITUATION) },
];

export function projectSituationPill(situation) {
  return SITUATION_PILLS[situation] || "none";
}
